import { Calendar, Popover, PopoverContent, PopoverTrigger } from '@bpinternal/ui-kit-next'
import { useState, type FC, type ReactNode } from 'react'

type Props = {
  children: ReactNode
  date?: Date
  onDateSelected?: (date: Date) => void
  align?: 'start' | 'end' | 'center'
}

export const DatePickerPopover: FC<Props> = ({ date, onDateSelected, children, align }) => {
  const [open, setOpen] = useState(false)
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent className="w-auto p-0" align={align}>
        <Calendar
          mode="single"
          selected={date}
          onSelect={(selectedDate) => {
            if (selectedDate) onDateSelected?.(selectedDate)
            setOpen(false)
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
}
